import React from "react";
import {
  CheckCircle,
  Clock,
  AlertCircle,
  ArrowRight,
  Send,
  XCircle,
  AlertTriangle,
  MinusCircle,
} from "lucide-react";

const STATUS_CONFIG = {
  new: {
    icon: Clock,
    label: "New",
    bgColor: "bg-muted",
    textColor: "text-muted-foreground",
  },
  in_progress: {
    icon: ArrowRight,
    label: "In Progress",
    bgColor: "bg-info/20",
    textColor: "text-info",
  },
  submitted: {
    icon: Send,
    label: "Submitted",
    bgColor: "bg-brand/20",
    textColor: "text-brand",
  },
  approved: {
    icon: CheckCircle,
    label: "Approved",
    bgColor: "bg-success/20",
    textColor: "text-success",
  },
  rejected: {
    icon: XCircle,
    label: "Rejected",
    bgColor: "bg-destructive/20",
    textColor: "text-destructive",
  },
  declined: {
    icon: XCircle,
    label: "Declined",
    bgColor: "bg-destructive/20",
    textColor: "text-destructive",
  },
  needs_info: {
    icon: AlertCircle,
    label: "Needs Info",
    bgColor: "bg-warning/20",
    textColor: "text-warning",
  },
  // SOUND-688: `pended` removed — no longer a status any entity can hold. The
  // pended STATE is derived from open pends and rendered by the list/detail
  // pages, not by this generic status map.
  withdrawn: {
    icon: MinusCircle,
    label: "Withdrawn",
    bgColor: "bg-muted",
    textColor: "text-muted-foreground",
  },
  active: {
    icon: CheckCircle,
    label: "Active",
    bgColor: "bg-success/20",
    textColor: "text-success",
  },
  suspended: {
    icon: AlertTriangle,
    label: "Suspended",
    bgColor: "bg-warning/20",
    textColor: "text-warning",
  },
  closed: {
    icon: MinusCircle,
    label: "Closed",
    bgColor: "bg-muted",
    textColor: "text-muted-foreground",
  },
};

// Backwards-compat mapping for legacy MID status labels
const LEGACY_MAP = {
  "need to do": "new",
  "in progress": "in_progress",
  "not doing": "withdrawn",
};

function resolveStatus(status) {
  if (!status) return "new";
  const lower = status.toLowerCase();
  return LEGACY_MAP[lower] || lower;
}

export function StatusBadge({ status }) {
  const resolved = resolveStatus(status);
  const config = STATUS_CONFIG[resolved] || {
    icon: Clock,
    label: status,
    bgColor: "bg-muted",
    textColor: "text-muted-foreground",
  };
  const Icon = config.icon;

  return (
    <div
      className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium ${config.bgColor} ${config.textColor}`}
    >
      <Icon className={`w-4 h-4 mr-2 ${config.textColor}`} />
      {config.label}
    </div>
  );
}
